import type { VoidFunctionComponent, ReactNode } from 'react';
import Helmet from 'react-helmet';
import Loader from '../generic/Loader';
import NotFound from '../generic/NotFound';
import type { AsyncStatus } from '../../types';
import { PolicyType } from '../../types';
import { useIsQualityEnabled } from '../../helpers/features';

type ListQualityPoliciesPageProps = {
  renderPolicyList: (policyType: PolicyType) => ReactNode;
  status: AsyncStatus,
};

const ListQualityPoliciesPage: VoidFunctionComponent<ListQualityPoliciesPageProps> = ({
  renderPolicyList,
  status,
}) => {
  const hasQuality = useIsQualityEnabled();

  if (!hasQuality) {
    return <NotFound />;
  }

  return (
    <div className="container margin-top">
      <Helmet title="Policies" />
      {status?.errors?.map(error => <div className="alert alert-error">{error}</div>)}
      {status?.loading ? <Loader /> : renderPolicyList(PolicyType.QUALITY)}
    </div>
  );
};

export default ListQualityPoliciesPage;
